"use client";

import { FC, useCallback } from "react";
import { Checkbox } from "@/app/components/shadcn/checkbox";
import useModal from "@/app/lib/features/modal/modal.hook";
import { Agreement } from "@/app/lib/features/agreements/agreements.types";

interface AgreementCheckboxProps {
  agreement: Agreement;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const AgreementCheckbox: FC<AgreementCheckboxProps> = ({
  agreement,
  checked,
  onChange,
  disabled = false,
}) => {
  const { createModal } = useModal();

  const handleCheckboxChange = useCallback(
    (newChecked: boolean) => {
      if (!newChecked) {
        onChange(false);
      } else {
        createModal("consent", {
          title: agreement.title,
          type: "single",
          content: agreement.content,
          onAccept: () => {
            onChange(true);
          },
          onReject: () => {
            onChange(false);
          },
        });
      }
    },
    [agreement, onChange, createModal],
  );

  const openModal = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      createModal("consent", {
        title: agreement.title,
        type: "single",
        content: agreement.content,
        onAccept: () => {
          onChange(true);
        },
        onReject: () => {
          onChange(checked);
        },
      });
    },
    [agreement, checked, onChange, createModal],
  );

  return (
    <div className="flex flex-row items-start space-x-3 space-y-0">
      <Checkbox
        className="size-5 mt-0.5"
        id={`agreement-${agreement.id}`}
        checked={checked}
        disabled={disabled}
        onCheckedChange={handleCheckboxChange}
      />
      <div className="space-y-1 leading-none flex-1">
        <div
          onClick={openModal}
          className="text-sm text-gray-600 leading-5 cursor-pointer"
          dangerouslySetInnerHTML={{ __html: agreement.text }}
        />
      </div>
    </div>
  );
};

export default AgreementCheckbox;